export { component } from './component.js';
